import {
  DsmAppointmentStepMember,
  DsmAppointmentStepMemberEntry,
  DsmScenarioMemberKind
} from '../models/dsm-appointment-scenario.models';

/** A member as it already sits on a step, reshaped for a `PUT`/`POST` — its own id is not sent back. */
export function toDsmAppointmentStepMemberEntry(member: DsmAppointmentStepMember): DsmAppointmentStepMemberEntry {
  return {
    categoryId: member.memberKind === DsmScenarioMemberKind.Category ? member.targetId : undefined,
    subcategoryId: member.memberKind === DsmScenarioMemberKind.Subcategory ? member.targetId : undefined,
    subGroupName: member.subGroupName
  };
}
